<!-- header -->
<app-breadcrumb [styleBreadcrumb]="'page-heading'" [title]="'ASSESSMENTS'" [breadcrumb]="''" [count]="total"
  icon="fa-clipboard-list">
</app-breadcrumb>
<!-- body -->
<kendo-tabstrip #tabstrip>
  <kendo-tabstrip-tab title="{{ 'ASSESSMENTS' | translate }}" [selected]="true">
    <ng-template kendoTabContent>
      <app-assessment-grid (refreshAssessmentTotal)="setTotal($event)" [isDeleted]="false"></app-assessment-grid>
    </ng-template>
  </kendo-tabstrip-tab>
  <kendo-tabstrip-tab title="{{ 'ARCHIVED' | translate }}">
    <ng-template kendoTabContent>
      <app-assessment-grid (refreshAssessmentTotal)="setTotal($event)" [isDeleted]="true"></app-assessment-grid>
    </ng-template>
  </kendo-tabstrip-tab>
</kendo-tabstrip>